import commonStyles from "../../../styles/common.module.css";

type Props = {
  content: string;
};

const ProcessingDescription = ({ content }: Props) => {
  return <div className={commonStyles.processingDescription}>{content}</div>;
};

export default ProcessingDescription;
